// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Flyttet ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) => p['label'] + ' – handlingen er fullført',
  accButtonProgressStatus: (p: { label: string }) => p['label'] + ' – handlingen pågår',
  accColorPalette: () => 'Fargepalett',
  accColorSwatch: () => 'Fargekart',
  accCommandKey: () => 'Kommando',
  accContextMenuLabel: () => 'handlinger',
  accControlKey: () => 'Lukk',
  accPositionAfter: () => 'etter',
  accPositionBefore: () => 'før',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Trykk på og hold nede tastene ' +
    p['keyPressed'] +
    ' og Skift, og bruk deretter piltastene for å endre rekkefølgen.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Angi en fullstendig dato som dette: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Angi en måned og et år som dette: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Etikett',
  chart_labelGroup: () => 'Gruppe',
  chart_labelSeries: () => 'Serie',
  chart_labelValue: () => 'Verdi',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Velg en verdi.',
  checkbox_helpForCheckbox: () => 'Hjelp for avmerkingsboks',
  checkbox_requiredMessageDetail: () => 'Velg en verdi.',
  checkbox_selected: () => 'Avmerket',
  checkbox_unselected: () => 'Ikke avmerket',
  close: () => 'Lukk',
  collection_apply: () => 'Bruk',
  collection_cancel: () => 'Avbryt',
  collection_loaded: () => 'Lastet',
  collection_loading: () => 'Laster',
  collection_noData: () => 'Ingen data å vise.',
  collection_pixels: () => 'piksler',
  collection_resizeColumnDialog: () => 'Endre størrelse på kolonne',
  collection_resizeColumnMenu: () => 'Endre størrelse på kolonne...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Angi et tall mellom ' + p['MIN'] + ' og ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Velg alle rader',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Velg raden ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'Stigende',
  collection_sortColumnMenu: () => 'Sorter kolonne',
  collection_sortDescendingSubMenu: () => 'Synkende',
  collection_sortDisabled: () => 'Ikke sorterbar',
  collection_sortEnabled: () => 'Sorterbar',
  collection_width: () => 'Bredde',
  colorPicker_label: () => 'Fargevelger',
  confirmation: () => 'Bekreftelse',
  datePicker_currentDate: () => 'Dagens dato',
  datePicker_goToToday: () => 'Gå til i dag',
  datePicker_label: () => 'Datovelger',
  datePicker_month: () => 'Måned',
  datePicker_months: () => 'Måneder',
  datePicker_next: () => 'Neste',
  datePicker_nextDecade: () => 'Neste tiår',
  datePicker_nextMonth: () => 'Neste måned',
  datePicker_prev: () => 'Forrige',
  datePicker_prevDecade: () => 'Forrige tiår',
  datePicker_prevMonth: () => 'Forrige måned',
  datePicker_restricted: () => 'Begrenset',
  datePicker_selected: () => 'Valgt',
  datePicker_today: () => 'I dag',
  datePicker_weekNum: (p: { NUM: string }) => 'Uke ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Ukenummer',
  datePicker_year: () => 'År',
  datePicker_years: () => 'År',
  diagram_promotedLink: () => '1 kobling',
  diagram_promotedLinkAriaDesc: () => 'Indirekte',
  diagram_promotedLinks: (p: { num_links: string }) => p['num_links'] + ' koblinger',
  error: () => 'Feil',
  expandableList_expandCollapseInstructionText: () =>
    'Bruk piltastene for å utvide og trekke sammen',
  expandableList_groupCollapse: () => 'Sammentrukket',
  expandableList_groupExpand: () => 'Utvidet',
  filePicker_addFiles: () => 'Legg til filer',
  filePicker_dropzonePrimaryText: () => 'Dra og slipp',
  filePicker_dropzoneSecondaryText: () => 'Velg en fil, eller slipp en fil her',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Velg eller slipp filer her',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Du kan ikke laste filer av følgende typer: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Last én fil om gangen',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Du kan ikke laste filer av typen ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'ukjent',
  formControl_clear: () => 'Nullstill',
  formControl_day: () => 'Dag',
  formControl_empty_segment: () => 'Tomt',
  formControl_helpAvailable: () => 'Hjelp – tilgjengelig',
  formControl_hide: () => 'Skjul',
  formControl_hour: () => 'Time',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Du har nådd grensen på ' +
    ((
      { one: new Intl.NumberFormat('no').format(p['CHARACTER_LIMIT']) + '-tegn' } as Partial<
        Record<Intl.LDMLPluralRule, string>
      >
    )[new Intl.PluralRules('no').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('no').format(p['CHARACTER_LIMIT']) + '-tegn') +
    '.',
  formControl_loading: () => 'Laster',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Du kan angi opptil ' + p['MAX_LENGTH'] + ' tegn.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maksimumslengden, ' + p['MAX_LENGTH'] + ', er overskredet.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' tegn igjen.',
  formControl_millisecond: () => 'Millisekund',
  formControl_minute: () => 'Minutt',
  formControl_month: () => 'Måned',
  formControl_readOnly: () => 'Skrivebeskyttet',
  formControl_requiredMessageDetail: () => 'Angi en verdi.',
  formControl_second: () => 'Sekund',
  formControl_selectionExactMessageDetail: (p: { n: string }) => 'Velg ' + p['n'] + ' verdier.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Du har nådd utvalgsgrensen på ' + p['max'] + '.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Velg fra ' + p['min'] + ' til ' + p['max'] + ' verdier.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Velg minst ' + p['min'] + ' verdier.',
  formControl_show: () => 'Vis',
  formControl_year: () => 'År',
  gantt_labelDate: () => 'Dato',
  gantt_labelEnd: () => 'Slutt',
  gantt_labelLabel: () => 'Etikett',
  gantt_labelRow: () => 'Rad',
  gantt_labelStart: () => 'Start',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Finner ingen samsvarende seksjon.',
  indexer_keyboardInstructionText: () => 'Trykk på Enter hvis du vil velge verdien.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Mellom ' + p['FROM_SECTION'] + ' og ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Dobbelttrykk og hold, slik at bevegelsesmodus aktiveres, og dra deretter opp og ned hvis du vil justere verdien.',
  info: () => 'Opplysninger',
  inputColor_selectColor: () => 'Velg en farge',
  inputDateMask_date_cleared: () => 'Dato nullstilt',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Tomt',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'åååå',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Angi en dato som er på eller før tidspunktet ' + p['max'] + '.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Angi en dato som er på eller etter tidspunktet ' + p['min'] + '.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Angi en tilgjengelig dato.',
  inputDatePicker_instruction: () => 'Trykk på tabulatortasten hvis du vil gå til kalenderen.',
  inputDatePicker_selectDate: () => 'Velg en dato',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Angi en måned og et år som er på eller før tidspunktet ' + p['max'] + '.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Angi en måned og et år som er på eller etter tidspunktet ' + p['min'] + '.',
  inputNumber_converterParseError: () => 'Angi et tall.',
  inputNumber_decrease: () => 'Reduser',
  inputNumber_increase: () => 'Øk',
  inputPassword_hidden: () => 'Passord skjult',
  inputPassword_hide: () => 'Skjul passord',
  inputPassword_show: () => 'Vis passord',
  inputSensitiveText_hidden: () => 'Sensitiv tekst skjult',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Angi et klokkeslett som er ' + p['max'] + ' eller tidligere.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Angi et klokkeslett som er ' + p['min'] + ' eller senere.',
  inputTimeMask_time_cleared: () => 'Tidspunkt for nullstilling',
  labelNone: () => 'Ingen',
  list_msgFetchCompleted: () => 'Lastet',
  list_msgFetchingData: () => 'Laster',
  list_suggestion: () => 'Forslag',
  menu_stateLoading: () => 'Laster',
  messageToast_allMessagesClosed: () => 'Alle sprettoppvarsler er lukket.',
  message_close: () => 'Lukk',
  message_confirmation: () => 'Vellykket',
  message_error: () => 'Feil',
  message_info: () => 'Opplysninger',
  message_navigationFromMessagesRegion: () => 'Åpner meldingsområde. Trykk på F6 for å navigere.',
  message_navigationToMessagesRegion: () =>
    'Meldingsområdet inneholder nye meldinger. Trykk på F6 hvis du vil navigere.',
  message_navigationToTouch: () => 'Meldingsområdet inneholder nye meldinger.',
  message_warning: () => 'Advarsel',
  noData_message: () => 'Ingen elementer å vise',
  overflowItemLabel: () => 'Flere faner',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Dobbelttrykk hvis du vil lukke det åpne hurtigvinduet.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Åpner hurtigvindu. Trykk på F6 hvis du vil navigere mellom hurtigvinduet og den tilhørende kontrollen.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Hurtigvinduet er åpnet. Trykk på F6 hvis du vil navigere mellom hurtigvinduet og den tilhørende kontrollen.',
  progressIndeterminate: () => 'Pågår',
  radioButton_checked: () => 'Alternativknapp avmerket',
  radioButton_selected: () => 'Alternativknapp valgt',
  radioButton_unchecked: () => 'Alternativknapp ikke avmerket',
  radioButton_unselected: () => 'Alternativknapp ikke valgt',
  radio_helpForRadio: () => 'Hjelp for alternativknapp',
  radio_requiredMessageDetail: () => 'Velg en verdi.',
  selectMultiple_apply: () => 'Bruk',
  selectMultiple_back: () => 'Tilbake',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Bruk venstre og høyre piltast for å utheve valgte verdier.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Trykk på Tilbake-tasten eller slettetasten hvis du vil fjerne den valgte verdien.',
  selectMultiple_selectedValues: () => 'Valgte verdier',
  selectMultiple_showSelectedValues: () => 'Vis bare valgte verdier.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' verdier er valgt.',
  select_addToList: () => 'Legg til i liste',
  select_addToListAvailable: () => 'Legg til i liste – tilgjengelig',
  select_closeDropdown: () => 'Trykk på Escape for å lukke.',
  select_moreSearchOptions: () => 'Flere søkevalg',
  select_moreSearchOptionsAvailable: () => 'Flere søkevalg – tilgjengelig',
  select_noMatchesFound: () => 'Ingen samsvar funnet.',
  select_oneMatchFound: () => 'Finner ett treff',
  select_requiredMessageDetail: () => 'Velg en verdi.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' samsvar funnet',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' eller flere samsvar funnet',
  selectorAll_deselectAll: () => 'Opphev alle valg',
  selectorAll_selectAll: () => 'Velg alle',
  selector_selected: () => 'Avmerket',
  selector_unselected: () => 'Ikke avmerket',
  sheet_close: () => 'Lukk',
  switch_off: () => 'Av',
  switch_on: () => 'På',
  tabBarNavigationList_removeCueText: () => 'Kan fjernes',
  tabBar_tabContainsErrors: () => 'Inneholder feil',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => 'Fjernet ' + p['itemKey'],
  tabbar_labelContextMenu: () => 'har kontekstmeny',
  tabbar_labelMoveLeft: () => 'Flytt til venstre',
  tabbar_labelMoveRight: () => 'Flytt til høyre',
  tabbar_labelRemove: () => 'Fjern',
  timeComponent_tooltipZoomIn: () => 'Zoom inn',
  timeComponent_tooltipZoomOut: () => 'Zoom ut',
  timeConverter_parseError: () => 'Angi et fullstendig klokkeslett.',
  train_current: () => 'Gjeldende',
  train_message_type: () => 'Meldingstype',
  train_not_visited: () => 'Ikke besøkt',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Trinn ' + p['currentStep'] + ' av ' + p['numberOfSteps'],
  train_visited: () => 'Besøkt',
  userAssistance_learnMore: () => 'Jeg vil vite mer',
  userAssistance_required: () => 'Nødvendig',
  vis_clearSelection: () => 'Nullstill valg',
  vis_drillable: () => 'Drillbar',
  vis_invalidData: () => 'Ugyldige data',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' av ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Valg med markeringshåndtak',
  vis_marqueeZoomTooltip: () => 'Zoom med markeringshåndtak',
  vis_noData: () => 'Ingen data å vise',
  vis_panTooltip: () => 'Panorer',
  vis_stateCollapsed: () => 'Sammentrukket',
  vis_stateExpanded: () => 'Utvidet',
  vis_stateLoaded: () => 'Lastet',
  vis_stateLoading: () => 'Laster',
  vis_stateSelected: () => 'Valgt',
  vis_stateUnselected: () => 'Ikke valgt',
  warn: () => 'Advarsel'
};
export default bundle;
